export const newUsers = [
  {
    id: 1,
    username: "torvalds",
    name: "Linus Torvalds",
    description: "Finnish-American software engineer best known as the creator of the Linux kernel, which serves as the foundation of the Linux operating system. Linus Torvalds is a pioneering figure in the open-source software community.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 2,
    username: "brendaneich",
    name: "Brendan Eich",
    description: "American technologist who is renowned for his role in creating the JavaScript programming language. Brendan Eich has made significant contributions to web development and browser technology.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 3,
    username: "gvanrossum",
    name: "Guido van Rossum",
    description: "Dutch programmer widely recognized as the creator of the Python programming language. Guido van Rossum's work has had a profound impact on the world of software development.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 4,
    username: "timbl",
    name: "Tim Berners-Lee",
    description: "English computer scientist and inventor of the World Wide Web. Tim Berners-Lee's pioneering work has revolutionized the way information is accessed and shared on the internet.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 5,
    username: "dhh",
    name: "David HH",
    description: "Danish-American software developer and entrepreneur best known as the creator of the Ruby on Rails web application framework. David Heinemeier Hansson has played a key role in the development of web technologies.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 6,
    username: "martinfowler",
    name: "Martin Fowler",
    description: "British software developer and author known for his expertise in software architecture and design patterns. Martin Fowler has written influential books and articles on software development.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 7,
    username: "ry",
    name: "Ryan Dahl",
    description: "American software engineer and the creator of Node.js, a popular JavaScript runtime environment. Ryan Dahl's work has enabled server-side JavaScript development.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 8,
    username: "gaearon",
    name: "Dan Abramov",
    description: "Software engineer known for coauthoring Redux and contributing to the development of the React JavaScript library. Dan Abramov is a prominent figure in the React community.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 9,
    username: "yyx990803",
    name: "Evan You",
    description: "Chinese-Canadian software developer recognized as the creator of Vue.js, a popular JavaScript framework. Evan You has made significant contributions to front-end web development.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 10,
    username: "taylorotwell",
    name: "Taylor Otwell",
    description: "Canadian software developer known for creating the Laravel PHP framework. Taylor Otwell's work has simplified web application development in the PHP community.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 11,
    username: "clattner",
    name: "Chris Lattner",
    description: "American computer scientist and software engineer who created the Swift programming language, which is used for iOS, macOS, watchOS, and tvOS app development. Chris Lattner's work has greatly influenced the Apple developer ecosystem.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 12,
    username: "matz",
    name: "Yukihiro",
    description: "Japanese computer scientist and software developer best known as the creator of the Ruby programming language. Yukihiro Matsumoto's work has had a significant impact on the Ruby community.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 13,
    username: "midudev",
    name: "Miguel Ángel",
    description: "Spanish content creator, developer, and educator known for his presence on Twitch and contributions to the developer community. Miguel Ángel Durán shares valuable insights on programming and technology.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 14,
    username: "fabpot",
    name: "Fabien Potencier",
    description: "French software developer and entrepreneur who founded Symfony, a popular PHP web application framework. Fabien Potencier has played a key role in the PHP development ecosystem.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 15,
    username: "dgageot",
    name: "David Gageot",
    description: "French software developer and active contributor to various open-source projects. David Gageot's work has advanced software development practices and collaboration within the community.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 16,
    username: "jeresig",
    name: "John Resig",
    description: "American software developer best known as the creator of the jQuery JavaScript library, a widely used tool for simplifying web development. John Resig has made web development more accessible to many developers.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 17,
    username: "defunkt",
    name: "Chris Wanstrath",
    description: "American software developer and entrepreneur who co-founded GitHub, a leading platform for version control and collaborative software development. Chris Wanstrath has had a profound impact on the way developers collaborate on code.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 18,
    username: "mojombo",
    name: "Tom",
    description: "American software developer and entrepreneur who co-founded GitHub, a platform that has revolutionized the way software projects are managed and collaborated on. Tom Preston-Werner's contributions have shaped modern software development practices.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 19,
    username: "mxcl",
    name: "Max Howell",
    description: "Software developer known for creating Homebrew, a popular package manager for macOS. Max Howell's work has simplified software installation and management for macOS users.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 20,
    username: "kentcdodds",
    name: "Kent C.",
    description: "American author and speaker specializing in React and JavaScript development. Kent C. Dodds is a well-known figure in the React community, providing valuable educational content and insights.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 21,
    username: "sdras",
    name: "Sarah Drasner",
    description: "Canadian developer and advocate for modern web technologies. Sarah Drasner actively promotes web development best practices and contributes to the advancement of web technology.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 22,
    username: "rauchg",
    name: "Guillermo",
    description: "Argentinian software developer and the creator of Socket.io and Now.sh. Guillermo Rauch's work has enabled real-time communication in web applications and simplified server deployment.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 23,
    username: "b0rk",
    name: "Julia Evans",
    description: "Canadian author and creator of educational tech resources, including comics and tutorials on various technical topics. Julia Evans is known for making complex technical concepts accessible and engaging.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 24,
    username: "addyosmani",
    name: "Addy Osmani",
    description: "British software engineer working at Google, with a focus on web performance and developer tooling. Addy Osmani has contributed to tools and practices that improve web performance.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 25,
    username: "substack",
    name: "James Halliday",
    description: "American software developer known by the pseudonym 'Substack.' He has created many popular Node.js modules and is recognized for his contributions to the Node.js ecosystem.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 26,
    username: "paulirish",
    name: "Paul Irish",
    description: "American software engineer working at Google, advocating for modern web development practices and tools. Paul Irish's work has helped developers improve the performance and user experience of web applications.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 27,
    username: "mxstbr",
    name: "Max Stoiber",
    description: "Passionate software developer with a focus on React. Max Stoiber has created and contributed to various React-related projects and is an active member of the React community.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 28,
    username: "daneden",
    name: "Daniel Eden",
    description: "UI designer and developer known for his work on various design systems and UI components. Daniel Eden's contributions have enhanced the user interfaces of numerous applications.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 29,
    username: "muan",
    name: "Mu-An Chiou",
    description: "Product designer and web developer known for her creative work in designing user interfaces and web experiences. Mu-An Chiou's designs have enriched the user experiences of many digital products.",
    isVerified: true,
    isFollowing: false
  },
  {
    id: 30,
    username: "tenderlove",
    name: "Aaron Patterson",
    description: "Member of the Ruby on Rails Core Team and a prolific Ruby developer. Aaron Patterson's contributions have improved the Ruby programming language and the Ruby on Rails framework.",
    isVerified: false,
    isFollowing: false
  },
  {
    id: 31,
    username: "tj",
    name: "TJ Holowaychuk",
    description: "Software developer known for creating Express.js, a widely used Node.js web application framework, and many other open-source tools. TJ Holowaychuk has had a significant impact on the Node.js ecosystem.",
    isVerified: true,
    isFollowing: false
  }
];
